import comingSoon from 'images/coming-soon.png'

export default function ComingSoongSection() {
  return (
    <div className='h-[600px] grid place-items-center bg-slate-50 rounded-lg'>
      <img src={comingSoon} alt='' />
    </div>
  )
}
